module.exports = __webpack_public_path__ + "img/info-check.0fb67b5d.svg";